var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fontAwesomeClass)?_c('i',{class:_vm.fontAwesomeClass}):_c('i',{attrs:{"data-feather":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }